const trains = {
  train: "Train",
  trains: "Trains",
  fairConditions: "Fair Conditions",
  to: "to",
  earlier: "Earlier",
  later: "Later",
  adults: "Adults",
  child: "Child",
  senior: "Senior",
  seniors: "Seniors",
  price: "Price",
  for: "for",
  total: "Total",
  selected: "Selected",
  prebook: "Prebook",
  book: "Book",
  payment: "Payment",
  return: "Return",
  passengers: "Passengers",
  delivery: "Delivery",
  summary: "Summary",
  checkout: "Checkout",
  trainToastCorrectFillForm: "Please fill properly all the fields.",
  fareConditions: "Fare conditions",
  travelInfo: "Travel info",
  remarks: "Customer remarks",
  noServices: "No services",
  timesAndSeats: "Times and seats",
  mobileTicket: "Mobile ticket",
  stationTicket: "Collect at station",
  homeTicket: "Print at home",
  countryCode: "Country code",
  chooseTicket: "Choose ticket delivery method",
  ticketError: "Please select a ticket for all destinations",
  ticketDelivery: "Please select a ticket delivery method",
  passengerDetails: "Passenger details",
  waitWhileProcessingPayment:
    "Please wait while we process your payment, do not refresh or close the page.",
  reductionCardId: "Reduction card ID",
  countryOfResidence: "Country of residence",
  countryOfBirth: "Country of birth",
  documentCountry: "Document country",
  documentNumber: "Document number",
  expirationDate: "Expiration date",
  documentType: "Document type",
  travelerDocumentInfo: "Traveler document info",
  youth: "Youth",
  youths: "Youths",
  departTimeEarlyFirst: "Departure time (earliest first)",
};

export default trains;
